export interface Step {
    step: SearchStep;
    title: string;
    shouldBeDisplayed: boolean;
    instagramAccountCount?: DataCount;
}

export enum DataCount {
    ONE,
    MANY,
    NONE,
}

export enum SearchStep {
    LOCATION_COUNT = 'locationCount',
    INSTAGRAM_ACCOUNT_COUNT = 'instagramAccountCount',
    LOCATION_SCAN = 'locationScan',
}
